import { ThunkAction } from "redux-thunk";
import { IStep } from "../../processDetails/Models";
import { ThunkResult, Utilities } from "../../shared/utilities";
import { IAction } from "../model/IAction";
import { ElementType, IElement, IParameters } from "../model/IProcessData";
import { State } from "../model/State";

import { buildProcessOk, checkAndReportBuildError, reportUnhandledException, savingProcess } from "./SaveProcess";
import { TestElementId } from "./SidePanelActions";

export function runTestProcess(selectedAgentGroup: string): ThunkResult<void, State> {
    return async (dispatch, getState: () => State) => {
        try {
            dispatch(savingProcess());
            const selectedElement = getState().elements[TestElementId];
            const elementToRun: IElement = {
                id: selectedElement.id,
                selectedTypeId: selectedElement.selectedTypeId,
                parameters: selectedElement.parameters,
                type: ElementType.Task
            };
            const response = await Utilities.fetchBase(`api/process/runTestProcess/${selectedAgentGroup}`, elementToRun, "POST");
            const testExecutionId = await Utilities.parseJsonResponse<string>(response, checkAndReportBuildError);
            dispatch(buildProcessOk());
            Utilities.toastSuccess(FRENDS.Localizations.TestStarted);
            dispatch(testProcessStarted(testExecutionId, selectedElement.selectedTypeId as string, selectedElement.parameters));
        } catch (err) {
            reportUnhandledException(err, dispatch, FRENDS.Localizations.Process_SaveFailed);
        }
    };
}

export function fetchTestProcessData(executionId: string | null, environmentName: string): ThunkResult<void, State> {
    return (dispatch) => {
        try {
            dispatch({ type: START_TEST_PROCESS_FETCH });
            Utilities.getFetch(`api/details/${environmentName}/testProcessResult/${executionId}`)
                .then((data: IStep) => {
                    dispatch(testProcessCompleted(data));
                }).catch((ex) => {
                    dispatch({ type: FINISH_TEST_PROCESS_FETCH });
                });

        } catch (err) {
            reportUnhandledException(err, dispatch, FRENDS.Localizations.Process_SaveFailed);
        }
    };
}
export const START_TEST_PROCESS_FETCH = "START_TEST_PROCESS_FETCH";
export const FINISH_TEST_PROCESS_FETCH = "FINNISH_TEST_PROCESS_FETCH";

export const TEST_PROCESS_STARTED = "TEST_PROCESS_STARTED";
export function testProcessStarted(testExecutionId: string, selectedTaskId: string, parameters: IParameters): ITestProcessStartedAction {
    return {
        type: TEST_PROCESS_STARTED,
        testExecutionId: testExecutionId,
        selectedTaskId: selectedTaskId,
        parameters
    };
}

export interface ITestProcessStartedAction extends IAction {
    testExecutionId: string;
    selectedTaskId: string;
    parameters: any;
}

export const TEST_PROCESS_COMPLETED = "TEST_PROCESS_COMPLETED";
export function testProcessCompleted(result: IStep): ITestProcessCompletedAction {
    return {
        type: TEST_PROCESS_COMPLETED,
        result: result
    };
}

export interface ITestProcessCompletedAction extends IAction {
    result: IStep;
}

export function hideFetchingFromUi(): IAction {
    return {
        type: TEST_PROCESS_CANCELED
    };
}

export const TEST_PROCESS_CANCELED = "TEST_PROCESS_CANCELED";
export function testProcessCanceled(processExecutionId: string | null): ThunkResult<IAction, State> {
    return (dispatch) => {
        try {
            // no need to wait, if it fails, it fails ;)
            Utilities.postJsonAndParseResponse(`api/processList/instances/terminate/${processExecutionId}`, "");
            return dispatch(hideFetchingFromUi()) as any;
        } catch (err) {
            reportUnhandledException(err, dispatch, FRENDS.Localizations.Process_SaveFailed);
        }
    };
}
